import React from "react";

export const OperatorContext = React.createContext({});
